import {TipologicaDTO} from "angular-portal-shell-app";

const PG = "PG";
const PF = "PF";
const AN = "AN";

export class TipoAttore {
	value: boolean;
	descrizione: string;
}

export const TIPOLOGIE_ATTORE: Array<TipoAttore> = [
	{ value: false, descrizione: "richiedente" },
	{ value: true, descrizione: "incaricato-alla-trasmissione" },
];

export class TipologiaRichiedente {
	tipoRicorrente: TipologicaDTO;
	incaricatoTrasmissione: boolean;

	isIncaricato(): boolean {
		return this.incaricatoTrasmissione;
	}

	isPersonaGiuridica(): boolean {
		return this.tipoRicorrente?.codice == PG;
	}

	isPersonaFisica(): boolean {
		return this.tipoRicorrente?.codice == PF;
	}

	isAntistatario(): boolean {
		return this.tipoRicorrente?.codice == AN;
	}
}
